import { createCrudActions } from '../utils/crudGenerator';

const formatForfundays = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchForfundays,
    create: createForfunday,
    update: updateForfunday,
    delete: deleteForfundays
} = createCrudActions('FORFUNDAY', "JornadaForfun", formatForfundays);